export const POST_ORDER_SUMMARY_API = 'POST_ORDER_SUMMARY_API'
export const POST_ORDER_SUMMARY_API_SUCCESS = 'POST_ORDER_SUMMARY_API_SUCCESS'
export const ORDER_SUMMARY_API_ERROR_ACTION = 'ORDER_SUMMARY_API_ERROR_ACTION'



